import { useEffect, useState } from "react";
import { useAppContext } from "../providers/AppProvider";

export default function Loading() {
  const { loading } = useAppContext();
  const { message = "Loading..." } = loading;
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (loading.isLoading) {
      setProgress(0);
      const interval = setInterval(
        () =>
          setProgress((p) => {
            if (p == 90) {
              clearInterval(interval);
              return p;
            }
            return p + 5;
          }),
        100
      );
      return () => clearInterval(interval);
    } else {
      setProgress(0);
    }
  }, [loading.isLoading]);

  if (!loading.isLoading) return;

  return (
    <div className="flex flex-col h-screen w-full bg-[#181021] text-white justify-center place-items-center gap-3 p-5">
      <div className="w-full md:w-1/4 bg-[#444444] rounded-full h-1.5 self-center relative">
        <div
          className="bg-white h-1.5 rounded-full transition-all duration-500 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex justify-between w-full md:w-1/4">
        <p> {message}</p>
        <p>{progress}%</p>
      </div>
    </div>
  );
}
